export default (error) => {
    if (error.response && error.response.data) {
        if (error.response.data.error) {
            return {
                error: error.response.data.error
            }
        } else {
            return {
                error: error.response.data.statusText
            }
        }
    }
    return {
        error: error.message
    }
}